import useSessionState from "./useSessionState";

const useCurrentUser = () => {
  const { currentUser } = useSessionState();

  return currentUser;
};

export default useCurrentUser;
